/** @jsx jsx */

import type { HTMLAttributes } from 'react';
import { forwardRef } from 'react';
import { jsx, keyframes } from '@balance-web/core';
import type { BalanceTheme } from '@balance-web/theme';
import { useTheme } from '@balance-web/theme';

const fadeInAnim = keyframes({
  from: {
    opacity: 0,
  },
});
const easing = 'cubic-bezier(0.2, 0, 0, 1)';

export type BlanketProps = {
  animate?: boolean;
  elevation?: keyof BalanceTheme['elevation'];
} & HTMLAttributes<HTMLDivElement>;

export const Blanket = forwardRef<HTMLDivElement, BlanketProps>(
  ({ animate, elevation = 'modal', ...props }, ref) => {
    const theme = useTheme();
    const animationStyles = animate
      ? {
          animation: `${fadeInAnim} 320ms ${easing}`,
        }
      : null;

    return (
      <div
        ref={ref}
        css={[
          {
            backgroundColor: 'rgba(0, 0, 0, 0.3)', // TODO get this from the theme
            bottom: 0,
            left: 0,
            position: 'fixed',
            right: 0,
            top: 0,
            zIndex: theme.elevation[elevation || 'modal'],

            // support children
            alignItems: 'center',
            display: 'flex',
            justifyContent: 'center',
          },
          animationStyles,
        ]}
        id="overlay-blanket"
        role="presentation"
        {...props}
      />
    );
  }
);
